import API from 'utils/API'
import config from 'app/config'
import { message } from 'antd'

export const fetchAboutPakde = params => (
  () => new Promise((resolve, reject) => (
    API.get(
      `${process.env.APP_CONFIG.api_url_content}/about-pakde${params || ''}`,
      { headers: { 'x-api-key': config.api_key } },
    ).then(
      (response) => {
        const { data } = response
        if (data.meta.status) {
          resolve(data)
        } else {
          reject(data.meta.message)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)

export const updateAboutPakde = payload => (
  () => new Promise((resolve, reject) => (
    API.put(
      `${process.env.APP_CONFIG.api_url_content}/about-pakde`,
      payload,
      { headers: { 'x-api-key': config.api_key } },
    ).then(
      (response) => {
        const { data, meta } = response.data
        if (meta.status) {
          message.success('Banner Apps has been edited')
          resolve(data)
        } else {
          reject(meta.message)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)
